**Annualized Volatility** measures the annualized variation in daily return of an
index dispersion value.
